import { render, staticRenderFns } from "./FrontPostSingleCrochetIcon.vue?vue&type=template&id=1d22e81d&scoped=true"
import script from "./FrontPostSingleCrochetIcon.vue?vue&type=script&lang=js"
export * from "./FrontPostSingleCrochetIcon.vue?vue&type=script&lang=js"
import style0 from "./FrontPostSingleCrochetIcon.vue?vue&type=style&index=0&id=1d22e81d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d22e81d",
  null
  
)

export default component.exports